import { createContext } from 'react'
import type { useCreateToastContext } from './useCreateToastContext'

export const ToastContext = createContext<ReturnType<typeof useCreateToastContext>>({
  toasts: [],
  add: () => {
    throw new Error('ToastContext not provided')
  },
  remove: () => {
    throw new Error('ToastContext not provided')
  },
})
ToastContext.displayName = 'ToastContext'
